import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=0bb55c20&scoped=true"
import script from "./OrdersPage.vue?vue&type=script&lang=ts"
export * from "./OrdersPage.vue?vue&type=script&lang=ts"
import style0 from "./OrdersPage.vue?vue&type=style&index=0&id=0bb55c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb55c20",
  null
  
)

export default component.exports